import Link from "next/link";
const linkStyle = "text-base leading-[1.21875em] tracking-[0.03125em] text-white hover:text-white/80";
const TermsLinks = () => {
  return <div className='flex items-center gap-0' data-sentry-component="TermsLinks" data-sentry-source-file="TermsLinks.tsx">
      <Link href='/privacy' className={linkStyle} data-sentry-element="Link" data-sentry-source-file="TermsLinks.tsx">
        Privacy
      </Link>
      <span className='px-1 text-base leading-[1.21875em] text-white'>|</span>
      <Link href='/terms' className={linkStyle} data-sentry-element="Link" data-sentry-source-file="TermsLinks.tsx">
        Terms
      </Link>
      {/* <span className='px-1 text-base leading-[1.21875em] text-white'>|</span>
       <Link href='/sitemaps' className={linkStyle}>
        Sitemap
       </Link> */}
    </div>;
};
export default TermsLinks;